<template>
    <div class="answer-list-content answer-list-no-other-symptoms">

        <!-- ----------------------------------------- -->
        <!-- NO OTHER SYMPTOMS -->
        <!-- ----------------------------------------- -->

        <div v-if="getCurrentAssessmentStatus === getAssessmentStatuses.NO_OTHER_SYMPTOMS && getCurrentQuestion && getCurrentQuestion.answers" class="answer-items">

            <div v-for="answer in getCurrentQuestion.answers"
                 :key="answer.code"
                 :ref="'answer-item-'+answer.code"
                 class="answer-item"
            >
                <span @click.once="handleClickAnswer(answer, getCurrentQuestion)"
                      :id="'NO_OTHER_S_' + answer.code"
                      class="answer-item-text"
                >{{answer.text}}</span>
            </div>

        </div>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'AnswerListNoOtherSymptoms',

        data() {
            return {
                // mustShowStartNewAssessmentBtn: false
            };
        },
        computed: {
            ...mapGetters({
                getAssessmentStatuses: 'ChatBotStore/getAssessmentStatuses',
                getNoOtherSymptomAnswers: 'ChatBotStore/getNoOtherSymptomAnswers',
                getConversationMessageTypes: 'ChatBotStore/getConversationMessageTypes',

                getCurrentAssessmentStatus: 'ChatBotStore/getCurrentAssessmentStatus',
                getCurrentQuestion: 'ChatBotStore/getCurrentQuestion',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getEntityTypes: 'ChatBotStore/getEntityTypes'
            })
        },
        updated: function () {

            if (this.getCurrentQuestion !== null) {
                this.$nextTick(function () {
                    this.$emit('onAnswerListUpdated');
                });
            }
        },

        methods: {

            capitalizeFirstLetter (string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },

            handleClickAnswer (clickedAnswer) {

                this.$emit("onClickedAnswer");

                let clickedAnswerElem = this.$refs['answer-item-'+clickedAnswer.code][0];
                clickedAnswerElem.classList.add('answer-item-clicked');

                setTimeout(() => {

                    let clickedAnswerText;
                    if (clickedAnswer.code === this.getNoOtherSymptomAnswers.NO) {
                        clickedAnswerText = this.capitalizeFirstLetter(this.text("api.label.no"));
                    }
                    else {
                        clickedAnswerText = this.capitalizeFirstLetter(this.text("api.label.yes"));
                    }

                    this.$store.commit("ChatBotStore/appendConversationMessage", {
                        text: clickedAnswerText,
                        type: this.getConversationMessageTypes.SENT,
                        code: clickedAnswer.code,
                        entityType: this.getEntityTypes.NO_OTHER_SYMPTOM
                    });

                    this.$store.dispatch("ChatBotStore/submitConfirmNoOtherSymptoms", clickedAnswer);
                }, 650);

            },

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>




</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerListNoOtherSymptoms.vue